module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-15.b01e34bb.png";